import React, { useState, useEffect } from "react";
import { Avatar } from "@mui/material";
import ModalSkeleton from "./ModalSkeleton";
import IMG from "../assets/images/Companies_bg.png";
import "../assets/styles/appliedCraftmanModal.css";
import { apiHeader, imageUrl, pdfUrl, URL } from "../Config/apiUrl";
import { useHistory } from "react-router-dom";
import { Col, Row, Form, Modal, Button } from "react-bootstrap";
import { useSelector } from "react-redux";
import { Get, Post } from "../Axios/AxiosFunctions";
import { toast } from "react-toastify";
import { FaUpload } from "react-icons/fa";

function JobApplyModal({ open, setOpen, isLoading, onSubmit }) {
  const [motivationalLetter, setMotivationalLetter] = useState(null);
  const [motivationalLetterFile, setMotivationalLetterFile] = useState(null);
  const [comment, setComment] = useState("");

  // uploadImages
  const uploadImages = (
    event,
    setterFile,
    setterDisplay,
    c = false,
    imageValidation = false,
    pdfValidation = false
  ) => {
    if (event.target.files.length > 0) {
      // pdfValidation
      if (pdfValidation) {
        if (event.target.files?.length > 0) {
          if (!["application/pdf"].includes(event.target.files[0].type)) {
            return toast.error(
              "Please upload a valid CV [only pdf is allowed]"
            );
          }
        }
      }

      setterFile(event.target.files[0]);
      let reader = new FileReader();
      reader.onload = (event) => {
        setterDisplay(event.target.result);
      };

      reader.readAsDataURL(event.target.files[0]);
    }
  };

  return (
    <ModalSkeleton
      title="Attach Extra Info (optional)"
      open={open}
      setOpen={setOpen}
    >
      <section>
        <Col lg={12}>
          <div className="doc-container-x">
            <label>
              <p>
                {`${
                  motivationalLetterFile
                    ? `${motivationalLetterFile?.name.substr(0, 20)}${
                        motivationalLetterFile?.name.length > 20 ? "...pdf" : ""
                      }`
                    : "Add Motivational Letter"
                }`}
              </p>
              <FaUpload className="doc-container-xixon" />
              <input
                type="file"
                accept="application/pdf"
                size="5"
                class="file_upload_form3rd"
                onChange={(e) =>
                  uploadImages(
                    e,
                    setMotivationalLetterFile,
                    setMotivationalLetter,
                    true,
                    false,
                    true
                  )
                }
              />
            </label>
          </div>
        </Col>

        <Row>
          <h5 className="font-26">Your Comments</h5>
          <Col md={12} className="mb-3">
            <Form.Control
              as="textarea"
              rows={5}
              placeholder="Comment for your application"
              onChange={(e) => setComment(e.target.value)}
              name="comment"
              value={comment}
            />
          </Col>
        </Row>
      </section>

      <Modal.Footer>
        <Button
          disabled={isLoading}
          variant="primary"
          onClick={onSubmit.bind(this, motivationalLetterFile, comment)}
        >
          {isLoading ? "Please wait..." : "Apply"}
        </Button>
      </Modal.Footer>
    </ModalSkeleton>
  );
}

export default JobApplyModal;
